var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",class:_vm.isMobile ? 'home-mobile' : 'home-pc'},[_c('mini-menu',{attrs:{"color":"#3D3D3D","sub-color":"#2D1D64","title":"首页"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }